import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";

interface Props {
  bankName: string;
  isDefaultLanguage: boolean;
}

/**
 * Component to display terms for ASK when creating a new account.
 * @param params
 * @returns a box with texts.
 */
export const AskTerms = ({ bankName, isDefaultLanguage }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <InfoBoxComponent header={texts.ASK_TERMS_LINK}>
      <div className="flex pt-3">
        <Typography variant="H5">{texts.ASK_TERMS_HEADER}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">
          {texts.ASK_TERMS_1} {bankName} {texts.ASK_TERMS_1_A}
        </Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_TERMS_2}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_TERMS_3}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_TERMS_4}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_TERMS_5}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_TERMS_6}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_TERMS_7}</Typography>
      </div>
      <div>
        <Typography variant="Body">{texts.ASK_TERMS_8}</Typography>
      </div>
      <div className="flex mt-6">
        <Typography variant="Bold">{texts.ASK_TERMS_9}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_10}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_TERMS_11}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_12}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_TERMS_13}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_14}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_TERMS_15}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_16}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_TERMS_17}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_18}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_TERMS_19}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_TERMS_20_B}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_C}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_D}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_E}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_F}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_G}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_H}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_I}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_J}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_20_K}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Body">{texts.ASK_TERMS_20_L}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_TERMS_21}</Typography>
      </div>
      <div className="flex">
        <Typography variant="Body">{texts.ASK_TERMS_22}</Typography>
      </div>
      <div className="flex mt-3">
        <Typography variant="Bold">{texts.ASK_TERMS_23}</Typography>
      </div>
      <div className="fle pb-3">
        <Typography variant="Body">{texts.ASK_TERMS_24}</Typography>
      </div>
    </InfoBoxComponent>
  );
};
